import { useEffect } from 'react';

const ImportScript = (resourceUrl, uid) => {

  useEffect(() => {
    const existingScript = document.getElementById(uid);
    const script = document.createElement('script');
    if (!existingScript) {
      script.src = resourceUrl;
      script.async = true;
      script.id = uid;
      document.body.appendChild(script);
    }
    return () => {
      document.body.removeChild(script);
    }
  }, [resourceUrl]);
};
export default ImportScript;